export default __webpack_public_path__ + "static/media/payFastLogo@2x.9f51300d.png";